import {
  Wallet,
  Landmark,
  CheckCircle2,
  Coins,
  Clock,
} from "lucide-react";

/** Map chat quick-reply / payment chip ids to Lucide icons and clean labels. */
export const QUICK_REPLY_CONFIG = {
  cash: { icon: Wallet, label: "Cash" },
  bank: { icon: Landmark, label: "Bank" },
  paid_full: { icon: CheckCircle2, label: "Yes, paid in full" },
  paid_deposit: { icon: Coins, label: "Paid a deposit" },
  not_yet: { icon: Clock, label: "Not yet" },
  full: { icon: CheckCircle2, label: "Paid in full" },
  partial: { icon: Coins, label: "Partial" },
  paid: { icon: CheckCircle2, label: "Paid in full" },
  unpaid: { icon: Clock, label: "Not yet" },
};

export function getQuickReplyDisplay(chip) {
  const cfg = QUICK_REPLY_CONFIG[chip?.id];
  if (cfg) {
    const cleanLabel = (chip?.label || "")
      .replace(/^[\u{1F300}-\u{1FAFF}\u2600-\u27BF]\s*/u, "")
      .trim();
    return { icon: cfg.icon, label: cleanLabel || cfg.label };
  }
  const label = (chip?.label || "")
    .replace(/^[\u{1F300}-\u{1FAFF}\u2600-\u27BF]\s*/u, "")
    .trim();
  return { icon: null, label: label || chip?.id };
}
